var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EB4B0A",
    fillRule: "evenodd",
    d: "M24 45.6c3.84 0 7.44-.96 10.8-2.88 3.36-1.92 6-4.56 7.92-7.92 1.92-3.36 2.88-6.96 2.88-10.8 0-3.84-.96-7.44-2.88-10.8-1.92-3.36-4.56-6-7.92-7.92C31.44 3.36 27.84 2.4 24 2.4c-3.84 0-7.44.96-10.8 2.88-3.36 1.92-6 4.56-7.92 7.92C3.36 16.56 2.4 20.16 2.4 24c0 3.84.96 7.44 2.88 10.8 1.92 3.36 4.56 6 7.92 7.92 3.36 1.92 6.96 2.88 10.8 2.88zm0 2.4c-4.32 0-8.32-1.08-12-3.24C8.32 42.6 5.4 39.68 3.24 36 1.08 32.32 0 28.32 0 24s1.08-8.32 3.24-12C5.4 8.32 8.32 5.4 12 3.24 15.68 1.08 19.68 0 24 0s8.32 1.08 12 3.24c3.68 2.16 6.6 5.08 8.76 8.76C46.92 15.68 48 19.68 48 24s-1.08 8.32-3.24 12c-2.16 3.68-5.08 6.6-8.76 8.76C32.32 46.92 28.32 48 24 48zm1.68-30.72c0 .64-.16 1.08-.48 1.32-.32.24-.72.36-1.2.36s-.88-.12-1.2-.36c-.32-.24-.48-.64-.48-1.2 0-.56.16-1 .48-1.32.32-.32.72-.48 1.2-.48s.88.16 1.2.48c.32.32.48.72.48 1.2zm-.24 14.16c0 .64-.32.96-.96.96h-.96c-.8 0-1.12-.32-.96-.96v-9.36c0-.48.4-.72 1.2-.72h.48c.8 0 1.2.24 1.2.72v9.36z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info_icon.42787804c1c3fbd848e184e551e6b7ab.svg";
export { ForwardRef as ReactComponent };